// extracted by mini-css-extract-plugin
module.exports = {"PaymentIcons":"PaymentIcons___1_G6_","loading":"loading___2FvCU"};